import { useEffect, useRef, useState } from "react";
import { STATS } from "@/data/content";

function CountUp({ value, suffix }) {
  const ref = useRef(null);
  const [n, setN] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        const dur = 1400;
        const start = performance.now();
        const step = (now) => {
          const t = Math.min(1, (now - start) / dur);
          const eased = 1 - Math.pow(1 - t, 3);
          setN(Math.round(eased * value));
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [value]);
  return (
    <span ref={ref}>
      {n}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative py-24">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="glow-ring rounded-2xl border border-[var(--line)] p-8 sm:p-12">
          <div className="relative z-[2] grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
            {STATS.map((s) => (
              <div key={s.label} data-testid={`stat-${s.label}`} className="border-l border-[var(--line-strong)] pl-5">
                <div className="display text-[3rem] sm:text-[4rem] text-[var(--ink)] leading-none">
                  <CountUp value={s.value} suffix={s.suffix} />
                </div>
                <div className="label mt-4">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
